import React, { useCallback, useMemo } from 'react'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import {
  ScreenSize,
} from '../types/app'

export interface SizeSelector {
  (size: ScreenSize, smaller: any, bigger: any): any,
}

export const SIZE_VALUES = {
  small: 0,
  medium: 1,
  large: 2,
}

const withScreenSize = () => {
  const theme = useTheme()
  const mediumScreen = useMediaQuery(theme.breakpoints.up('sm'))
  const bigScreen = useMediaQuery(theme.breakpoints.up('md'))
  const screenSize = useMemo(() => {
    return bigScreen ?
      'large' :
      mediumScreen ?
        'medium' :
        'small'
  }, [
    mediumScreen,
    bigScreen,
  ])
  const select = useCallback((size: ScreenSize, bigger: any, smaller: any) => {
    return SIZE_VALUES[screenSize] >= SIZE_VALUES[size] ? bigger : smaller
  }, [
    screenSize,
  ])
  const isSize = useCallback((size: ScreenSize) => {
    return SIZE_VALUES[screenSize] >= SIZE_VALUES[size]
  }, [
    screenSize,
  ])
  return {
    screenSize,
    select,
    isSize,
  }
}

export default withScreenSize